import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import AppStoreBadge from '../AppStoreBadge';
import GooglePlayBadge from '../GooglePlayBadge';
import './PremiumFooter.css';

const PremiumFooter = () => {
  const { isDark } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer className="premium-footer">
      <div className="premium-footer-bg">
        <div className="premium-footer-gradient premium-footer-gradient-1" />
        <div className="premium-footer-gradient premium-footer-gradient-2" />
      </div>

      <div className="premium-footer-container">
        <div className="premium-footer-top">
          <div className="premium-footer-brand">
            <Link to="/" className="premium-footer-logo">
              <img
                src={isDark ? '/Canira White Logo updated.png' : '/Canira Black Logo updated .png'}
                alt="Canira"
              />
            </Link>
            <p className="premium-footer-tagline">
              The all-in-one media platform. Produce webinars, livestreams,
              podcasts, and digital experiences — powered by AI.
            </p>
            <div style={{ marginTop: '1.25rem' }}>
              <span style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', opacity: 0.6, marginBottom: '0.6rem' }}>Get the app</span>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <AppStoreBadge />
                <GooglePlayBadge />
              </div>
            </div>

            <div className="premium-footer-social">
              <span className="premium-footer-social-label">Follow us</span>
              <div className="premium-footer-social-icons">
                <a
                  href="https://www.instagram.com/canira.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Canira on Instagram"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 1.8c-3.15 0-3.52.01-4.76.07-1.15.05-1.77.24-2.19.4-.55.22-.94.47-1.35.88-.41.41-.66.8-.88 1.35-.16.42-.35 1.04-.4 2.19-.06 1.24-.07 1.61-.07 4.76s.01 3.52.07 4.76c.05 1.15.24 1.77.4 2.19.22.55.47.94.88 1.35.41.41.8.66 1.35.88.42.16 1.04.35 2.19.4 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c1.15-.05 1.77-.24 2.19-.4.55-.22.94-.47 1.35-.88.41-.41.66-.8.88-1.35.16-.42.35-1.04.4-2.19.06-1.24.07-1.61.07-4.76s-.01-3.52-.07-4.76c-.05-1.15-.24-1.77-.4-2.19a3.6 3.6 0 0 0-.88-1.35 3.6 3.6 0 0 0-1.35-.88c-.42-.16-1.04-.35-2.19-.4-1.24-.06-1.61-.07-4.76-.07Zm0 3.06a5.02 5.02 0 1 1 0 10.04 5.02 5.02 0 0 1 0-10.04Zm0 1.8a3.22 3.22 0 1 0 0 6.44 3.22 3.22 0 0 0 0-6.44Zm5.23-.35a1.17 1.17 0 1 1 0 2.34 1.17 1.17 0 0 1 0-2.34Z" />
                  </svg>
                </a>
                <a
                  href="https://www.facebook.com/canira.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Canira on Facebook"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12Z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/canira-inc"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Canira on LinkedIn"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.8 0 0 .78 0 1.75v20.5C0 23.2.8 24 1.77 24h20.45c.98 0 1.78-.8 1.78-1.75V1.75C24 .78 23.2 0 22.22 0Z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="premium-footer-links">
            <div className="premium-footer-column">
              <h4 className="premium-footer-heading">Platform</h4>
              <ul>
                <li><Link to="/features">Overview</Link></li>
                <li><Link to="/features/repurposing">Content Repurposing</Link></li>
                <li><Link to="/for-coaches">For Coaches</Link></li>
                <li><Link to="/for-churches">For Churches</Link></li>
                <li><Link to="/for-educators">For Educators</Link></li>
                <li><Link to="/for-speakers">For Speakers</Link></li>
                <li><Link to="/monetization">Monetization</Link></li>
                <li><Link to="/features/live-streaming">Live Streaming</Link></li>
                <li><Link to="/features/evergreen">Evergreen Webinars</Link></li>
                <li><Link to="/features/podcasts">Podcasts</Link></li>
                <li><Link to="/features/registration">Registration</Link></li>
                <li><Link to="/features/automation">Automation</Link></li>
              </ul>
            </div>

            <div className="premium-footer-column">
              <h4 className="premium-footer-heading">Company</h4>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/blog">Founder Log</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/compare">Compare</Link></li>
                <li><Link to="/help">Help Center</Link></li>
                <li><Link to="/demo">Book a Demo</Link></li>
                <li><Link to="/register">Get Started</Link></li>
                <li><Link to="/login">Login</Link></li>
              </ul>
            </div>

            <div className="premium-footer-column premium-footer-column-legal">
              <h4 className="premium-footer-heading">
                <span className="premium-footer-legal-dot" />
                Legal &amp; Compliance
              </h4>
              <ul>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/dmca">DMCA Policy</Link></li>
                <li><Link to="/trust">Trust &amp; Security</Link></li>
                <li><Link to="/data-processing">Data Processing Agreement</Link></li>
                <li><Link to="/data-deletion">Data Deletion Request</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="premium-footer-bottom">
          <p className="premium-footer-copyright">
            &copy; {year} Canira. All rights reserved.
          </p>
          <nav className="premium-footer-mini-links" aria-label="Compliance links">
            <Link to="/terms">Terms</Link>
            <span className="premium-footer-divider" aria-hidden="true">·</span>
            <Link to="/privacy">Privacy</Link>
            <span className="premium-footer-divider" aria-hidden="true">·</span>
            <Link to="/dmca">DMCA</Link>
            <span className="premium-footer-divider" aria-hidden="true">·</span>
            <Link to="/trust">Trust &amp; Security</Link>
            <span className="premium-footer-divider" aria-hidden="true">·</span>
            <Link to="/data-processing">DPA</Link>
            <span className="premium-footer-divider" aria-hidden="true">·</span>
            <Link to="/data-deletion">Data Deletion</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default PremiumFooter;
